import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Importar las traducciones
import enTranslation from '@/locales/en/translation.json'
import esTranslation from '@/locales/es/translation.json'

const resources = {
  en: {
    translation: enTranslation
  },
  es: {
    translation: esTranslation
  }
}

const syncDocumentLanguage = (language?: string) => {
  if (typeof document === 'undefined') return

  const baseLanguage = language?.toLowerCase().split('-')[0]
  const resolvedLanguage = baseLanguage === 'es' ? 'es' : 'en'

  document.documentElement.lang = resolvedLanguage
  document.documentElement.setAttribute('translate', 'no')
  document.documentElement.classList.add('notranslate')
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  })
  .then(() => syncDocumentLanguage(i18n.resolvedLanguage || i18n.language))

i18n.on('languageChanged', syncDocumentLanguage)

export default i18n
